


import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

import { ERROR_MESSAGES } from './GlobalMassage';
import { addUpdateEnquiry } from '../../Services/EnqueryApi';
import SuccessPopupModal from './SuccessPopupModal';
import { useAuth } from '../../Context/AuthContext';

const EnqueryModal = ({ show, onHide, }) => {
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const { setLoader, user } = useAuth()
  const [homeContactObj, setHomeContactObj] = useState({

    phoneNumber: null,
    message: null,
    email: null,
    firstName: null,
    lastName: null
  });
  const [modelAction, setModelAction] = useState([]);
  const AddStateBtnClick = async () => {

    let isValid = false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (
      homeContactObj.firstName === null ||
      homeContactObj.firstName === undefined ||
      homeContactObj.firstName === "" ||
      homeContactObj.lastName === null ||
      homeContactObj.lastName === undefined ||
      homeContactObj.lastName === "" ||
      homeContactObj.phoneNumber === null ||
      homeContactObj.phoneNumber === undefined ||
      homeContactObj.phoneNumber === "" ||
      homeContactObj.phoneNumber?.length < 10 ||
      homeContactObj.message === null ||
      homeContactObj.message === undefined ||
      homeContactObj.message === "" ||
      homeContactObj.email === null ||
      homeContactObj.email === undefined ||
      !emailRegex.test(homeContactObj.email) ||
      homeContactObj.email === ""
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
      firstName: homeContactObj.firstName,
      message: homeContactObj.message,
      email: homeContactObj.email,
      phoneNumber: homeContactObj.phoneNumber,
      pageName: 'header',
      serviceID: null,
      enquiryKeyID: null,
      lastName: homeContactObj.lastName

    };

    if (!isValid) {
      AddUpdateStateData(apiParam);
    }
  };

  const AddUpdateStateData = async (apiParam) => {

    try {
      let url = "/addUpdateEnquiry"; // Default URL for Adding Data

      const response = await addUpdateEnquiry(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          setShowSuccessModal(true);
          setModelAction("Enquiry Sent Successfully!"); //Do not change this naming convention

          // setIsAddUpdateActionDone(true);
        } else {
          // setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      //   setLoader(false);
      console.error(error);
    }
  };

  const closeAllModal = () => {
    setShowSuccessModal(false);
    onHide()

  };

  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal style={{ zIndex: 1300 }} show={show} backdrop="static" keyboard={false} centered>
        <Modal.Header style={{ color: "black", borderBottom: "none" }}>
          <Modal.Title>Contact Us</Modal.Title>
          <Button variant="light" onClick={onHide} style={{ border: "none" }}>✖</Button>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#fdf3e7", padding: "20px", borderRadius: "8px" }}>
          <h5 className="text-center mb-4 text-black">Send Us A Message</h5>
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    value={homeContactObj.firstName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let InputValue = e.target.value;
                      const updatedValue = InputValue.replace(
                        /[^a-zA-Z0-9\s@&.\-_]/g,
                        ""
                      );
                      setHomeContactObj((prev) => ({
                        ...prev,
                        firstName: updatedValue,
                      }));
                    }}
                    placeholder="First Name" />
                  {error &&
                    (homeContactObj.firstName === null ||
                      homeContactObj.firstName === undefined ||
                      homeContactObj.firstName === "") ? (
                    <span style={{ color: "red" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    value={homeContactObj.lastName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let InputValue = e.target.value;
                      const updatedValue = InputValue.replace(
                        /[^a-zA-Z0-9\s@&.\-_]/g,
                        ""
                      );
                      setHomeContactObj((prev) => ({
                        ...prev,
                        lastName: updatedValue,
                      }));
                    }}
                    placeholder="First Name" />
                  {error &&
                    (homeContactObj.lastName === null ||
                      homeContactObj.lastName === undefined ||
                      homeContactObj.lastName === "") ? (
                    <span style={{ color: "red" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Control
                    maxLength={10}
                    placeholder="Enter Contact Number"
                    value={homeContactObj.phoneNumber}
                    onChange={(e) => {
                      setErrorMessage('');
                      const value = e.target.value;
                      let FormattedNumber = value.replace(/[^0-9]/g, ''); // Allows only numbers

                      // Apply regex to ensure the first digit is between 6 and 9
                      FormattedNumber = FormattedNumber.replace(/^[0-5]/, '');
                      setHomeContactObj((prev) => ({
                        ...prev,
                        phoneNumber: FormattedNumber
                      }));
                    }} />
                  <span style={{ color: 'red' }}>
                    {error && (homeContactObj.phoneNumber === null || homeContactObj.phoneNumber === undefined || homeContactObj.phoneNumber === '')
                      ? ERROR_MESSAGES
                      : (homeContactObj.phoneNumber !== null || homeContactObj.phoneNumber !== undefined) && homeContactObj?.phoneNumber?.length < 10
                        ? 'Invalid phone Number'
                        : ''}
                  </span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Control type="email"
                    value={homeContactObj.email}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let InputValue = e.target.value;
                      const updatedValue = InputValue.replace(
                        /[^a-zA-Z0-9\s@&.\-_]/g,
                        ""
                      );
                      setHomeContactObj((prev) => ({
                        ...prev,
                        email: updatedValue,
                      }));
                    }}
                    placeholder="Email" />
                  {error && (
                    <>
                      {homeContactObj.email === null ||
                        homeContactObj.email === undefined ||
                        homeContactObj.email === "" ? (
                        <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                      ) : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(homeContactObj.email) ? (
                        <span style={{ color: "red" }}>Please enter a valid email address.</span>
                      ) : null}
                    </>
                  )}
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Control as="textarea" rows="4"
                    value={homeContactObj.message}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let InputValue = e.target.value;
                      const updatedValue = InputValue.replace(
                        /[^a-zA-Z0-9\s@&.\-_]/g,
                        ""
                      );
                      setHomeContactObj((prev) => ({
                        ...prev,
                        message: updatedValue,
                      }));
                    }}
                    placeholder="Your Message" />
                  {error &&
                    (homeContactObj.message === null ||
                      homeContactObj.message === undefined ||
                      homeContactObj.message === "") ? (
                    <span style={{ color: "red" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div class="button">
            <div class="button" data-aos-duration="1200">
              <button
                onClick={AddStateBtnClick}
                class="theme-btn13"
                href="#"
              >
                Submit{" "}
                <span class="arrow1">
                  <i class="fa-solid fa-arrow-right"></i>
                </span>
                <span class="arrow2">
                  <i class="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            {showSuccessModal && (
              <SuccessPopupModal
                show={showSuccessModal}
                onHide={() => closeAllModal()}
                setShowSuccessModal={setShowSuccessModal}
                modelAction={modelAction}
              />
            )}
          </div>
          {/* Add other buttons as needed */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EnqueryModal;
